import nielPic from "@/public/images/artists/niel.png";
import { Artist } from "@/types/types";

export const niel = {
  id: "32",
  name: "Niel",
  image: nielPic,
  description: `Introducing "Niel," a soulful maestro seamlessly blending pop and R&B. With vocals that exude emotion and depth, Niel creates an unforgettable presence in the music world. From groovy pop beats to soulful R&B ballads, Niel's delivers a rich and resonant experience that touches hearts.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fniel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["RnB", "Pop"],
      secondary: ["Singer", "Soulful", "Expressive", "Heartfelt"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
